import angular from 'angular'

import identityComponent from './identity.component'
import addRepresentativeModule from './addRepresentative/addRepresentative'

export default angular.module('app.pages.admin.loanRequestDetails.identity', [addRepresentativeModule.name])
  .directive('adminLoanRequestIdentity', identityComponent)
